import styled from 'styled-components';
import mediaQuery, { breakpoints } from 'styles/mediaQuery';

export const ChannelListItemWrapper = styled.li`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-areas: 'name metadata actions';
  align-items: center;
  gap: 15px;
  padding: 15px;

  border: 1px solid #e9ecef;
  border-top: none;
  border-bottom: none;
  border-radius: 0;

  ${mediaQuery.xs} {
    grid-template-columns: 1fr;
    grid-template-areas: 'name' 'metadata' 'actions';
  }

  & ~ & {
    border-top: 1px solid #e9ecef;
  }

  &:first-child {
    border-top: 1px solid #e9ecef;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  &:last-child {
    border-bottom: 1px solid #e9ecef;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
`;

export const LogoAndNameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  grid-area: name;

  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  p {
    font-size: 20px;
    font-weight: 700;
    margin: 0;
    color: #495057;
  }
`;

export const MetadataWrapper = styled.div`
  grid-area: metadata;
  display: flex;
  align-items: center;
`;

export const ActionsWrapper = styled.div`
  grid-area: actions;
  display: flex;
  align-items: center;
  gap: 5px;

  @media (min-width: ${breakpoints.SM}px) {
    justify-content: flex-end;
  }
`;
